import { Reveal, Eyebrow } from "./Reveal";
import { CAST } from "../data/content";

export const Characters = () => (
    <section id="cast" data-testid="cast-section" className="mx-auto max-w-[1500px] px-5 sm:px-8 py-24 sm:py-36">
        <Reveal className="mb-16 text-center">
            <Eyebrow>The Ensemble</Eyebrow>
            <h2 className="deck-heading font-display text-5xl sm:text-6xl tracking-[0.14em]">PILOT CAST</h2>
            <p className="mt-6 mx-auto max-w-md text-sm leading-relaxed text-zinc-500">
                The actors bringing the world of Deadly Ambition to life in the pilot episode.
            </p>
        </Reveal>

        <div className="flex flex-wrap justify-center gap-x-6 sm:gap-x-8 gap-y-12">
            {CAST.map((c, i) => (
                <Reveal key={c.id} delay={i * 0.06} className="w-[44%] sm:w-[29%] lg:w-[17.5%]">
                    <article data-testid={`cast-card-${c.id}`} className="group">
                        <div className="relative overflow-hidden rounded-xl border border-white/10">
                            <img
                                src={c.img}
                                alt={`${c.actor} as ${c.character} in Deadly Ambition`}
                                loading="lazy"
                                className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                            />
                            <div className="absolute inset-0 bg-[#d6c68e]/0 transition-colors duration-500 group-hover:bg-[#d6c68e]/[0.08]" />
                            <span className="absolute bottom-0 left-0 h-px w-0 bg-[#d6c68e] transition-all duration-700 group-hover:w-full" />
                        </div>
                        <h3 className="mt-4 text-center font-display text-[13px] sm:text-sm tracking-[0.2em] text-white">
                            {c.actor.toUpperCase()}
                        </h3>
                        <p className="mt-1 text-center font-serif italic text-sm text-[#d6c68e]">{c.character}</p>
                    </article>
                </Reveal>
            ))}
        </div>
    </section>
);
